<template>
  <div
    class="display_none"
    :id="id"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EmdTippyTemplateHTML',
  props: {
    id: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>

<style scoped>
.display_none{
  display: none;
}
</style>
